import styled from 'styled-components'


export const SC_StatusWrapper = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 16px;
  border-radius: 8px;
  font-size: 12px;
  z-index: 1000;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  min-width: 200px;
  display: none;
`

export const SC_StatusItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SC_StatusLabel = styled.span`
  font-weight: 500;
  margin-right: 12px;
  opacity: 0.8;
`

interface T_StatusValueProps {
  $status?: 'success' | 'warning' | 'error'
}

export const SC_StatusValue = styled.span<T_StatusValueProps>`
  font-weight: 600;
  color: ${({ $status }) => {
    switch ($status) {
    case 'success': return '#22c55e'
    case 'warning': return '#f59e0b'
    case 'error': return '#ef4444'
    default: return 'white'
    }
  }};
`
